import React from 'react'

import EditSuperadminForm from '../../modules/Superadmin/components/EditSuperadminForm'
export default function EditSuperadminPage() {
  return <EditSuperadminForm />
}
